import * as tslib_1 from "tslib";
import { InputField } from '../input_field';
var TextField = /** @class */ (function (_super) {
    tslib_1.__extends(TextField, _super);
    function TextField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'maxLength';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    TextField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "TextField",
            "maxLength": this.maxLength
        });
    };
    TextField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TextField;
}(InputField));
export { TextField };
//# sourceMappingURL=text_field.js.map